import { AppEnv } from '@aries/defi-toolkit/types';
import { AptosPriceServiceConnection } from '@pythnetwork/pyth-aptos-js';
import { uniq } from 'lodash';
import { getReserveConfig } from '../config';
import { getCurrentProfile } from '../lending/data';
import { getAriesProgram } from '../lending/market';

const PYTH_PROGRAM_ADDRESS =
  '0x7e783b349d3e89cf5931af376ebeadbfab855b3fa239b7ada8f5a92fbea6b387';

export const getPythUpdatePayload = (
  env: AppEnv,
  profile: ReturnType<typeof getCurrentProfile>,
  customCoin?: string[],
) => {
  const profilePositionCoins = uniq(
    profile.loanList
      .map(l => l.asset)
      .concat(profile.depositList.map(d => d.asset))
      .map(a => a.id)
      .concat(customCoin ?? []),
  );

  const pythPricesIds = uniq(
    getReserveConfig(env, getAriesProgram()).flatMap(config =>
      profilePositionCoins.find(c => c === config.coinAddress) &&
      config.pythPriceId
        ? [config.pythPriceId]
        : [],
    ),
  );

  if (pythPricesIds.length === 0) {
    return [];
  }

  if (env.isMainnet) {
    const conn = new AptosPriceServiceConnection(
      'https://hermes.pyth.network',
    );
    return conn.getPriceFeedsUpdateData(pythPricesIds);
  }
  if (env.isTestnet) {
    const conn = new AptosPriceServiceConnection(
      'https://hermes-beta.pyth.network',
    );
    return conn.getPriceFeedsUpdateData(pythPricesIds);
  }

  throw Error(`Pyth not supported under ${env}`);
};

export const getPythUpdateEntryFunctionPayload = async (
  env: AppEnv,
  profile: ReturnType<typeof getCurrentProfile>,
  customCoin?: string[],
) => {
  const vaas = await getPythUpdatePayload(env, profile, customCoin);
  if (vaas.length === 0) {
    return null;
  }

  return {
    type: 'entry_function_payload' as const,
    function: `${PYTH_PROGRAM_ADDRESS}::pyth::update_price_feeds_with_funder`,
    type_arguments: [],
    arguments: [vaas],
  };
};
